<template>
  <footer class="row__center__center p-12 bg-surface-4 onsurface text3">
    {{ $t('footer.copyright') }}
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
}
</script>

<style lang="scss" scoped>
footer {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
</style>
